const invitationPaths = ['/adviser/invitations/accept', '/adviser/client-invitations/accept'];
const uuid = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
export function isAdviserInvitationPath(pathname: string): boolean {
  return invitationPaths.includes(pathname);
}
export function adviserAuthReturn(
  search: string,
  trustedOrigin = typeof window === 'undefined'
    ? 'https://stratplan.invalid'
    : window.location.origin
): string | undefined {
  let candidate = new URLSearchParams(search).get('redirect_url');
  // Clerk rewrites its auth links to absolute URLs. Normalize only this app's exact origin.
  if (candidate && /^https?:\/\//i.test(candidate)) {
    try {
      const url = new URL(candidate);
      if (url.origin !== trustedOrigin || url.username || url.password) return undefined;
      candidate = url.pathname + url.search + url.hash;
    } catch {
      return undefined;
    }
  }
  if (candidate === '/adviser' || candidate === '/admin') return candidate;
  if (candidate?.startsWith('/company/')) {
    try {
      const url = new URL(candidate, 'https://stratplan.invalid');
      const match = url.pathname.match(/^\/company\/([^/]+)\/(ai-plan|visual-report)$/);
      if (url.origin !== 'https://stratplan.invalid' || url.hash || !match || !uuid.test(match[1]))
        return undefined;
      const parameter = match[2] === 'ai-plan' ? 'run' : 'reportId';
      const id = url.searchParams.get(parameter);
      const question = match[2] === 'ai-plan' ? url.searchParams.get('question') : null;
      if (url.searchParams.size === 0) return url.pathname;
      if (
        url.searchParams.size !== (question ? 2 : 1) ||
        !id ||
        !uuid.test(id) ||
        (question && !uuid.test(question))
      )
        return undefined;
      return `${url.pathname}?${parameter}=${encodeURIComponent(id)}${question ? `&question=${encodeURIComponent(question)}` : ''}`;
    } catch {
      return undefined;
    }
  }
  if (candidate?.startsWith('/adviser?')) {
    try {
      const url = new URL(candidate, 'https://stratplan.invalid');
      const practice = url.searchParams.get('practice');
      const plans = url.searchParams.get('tab') === 'ai-plans';
      if (
        url.pathname === '/adviser' &&
        !url.hash &&
        url.searchParams.size === (plans ? 2 : 1) &&
        practice &&
        uuid.test(practice)
      )
        return `/adviser?practice=${encodeURIComponent(practice)}${plans ? '&tab=ai-plans' : ''}`;
    } catch {
      /* Fall back to the normal sign-in destination. */
    }
    return undefined;
  }
  if (!candidate?.startsWith('/adviser/')) return undefined;
  try {
    const url = new URL(candidate, 'https://stratplan.invalid');
    if (
      url.origin !== 'https://stratplan.invalid' ||
      !isAdviserInvitationPath(url.pathname) ||
      !/^[a-f0-9]{64}$/.test(url.searchParams.get('token') || '')
    )
      return undefined;
    return `${url.pathname}${url.search}`;
  } catch {
    return undefined;
  }
}

/** Keep only explicitly supported application, plan, support and invitation journeys. */
export function protectedSignInPath(pathname: string, search = ''): string {
  const destination = isAdviserInvitationPath(pathname)
    ? pathname + search
    : pathname === '/adviser'
      ? adviserAuthReturn(`?redirect_url=${encodeURIComponent(pathname + search)}`) || '/adviser'
      : pathname === '/admin'
        ? '/admin'
        : adviserAuthReturn(`?redirect_url=${encodeURIComponent(pathname + search)}`);
  return destination ? `/sign-in?redirect_url=${encodeURIComponent(destination)}` : '/sign-in';
}
